import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';

const useStyles = ({ overwritestyles: { root } = {} }) => makeStyles({
  root: {
    ...root
  }
});

const StyledButton = props => {
  const { children } = props;
  const classes = useStyles(props)();

  return (
    <IconButton
      {...props}
      classes={{
        root: classes.root,
        disabled: classes.disabled
      }}
    >
      { children }
    </IconButton>
  );
};

StyledButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  overwritestyles: PropTypes.objectOf(PropTypes.any),
};

StyledButton.defaultProps = {
  overwritestyles: [],
};

export default StyledButton;